import { UserPermission, UserProfile } from 'commons/types/user';
import { useCallback, useContext } from 'react';
import { UserContext, UserContextData } from './context';

export type UserContextWithHelpers = UserContextData & {
  hasProfiles: (profiles: UserProfile[]) => boolean;
  hasResource: (resources: UserPermission[]) => boolean;
};

export const useUserData = (): UserContextWithHelpers => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserData must be used within a UserProvider');
  }

  const hasProfiles = useCallback(
    (profiles: UserProfile[]) => profiles.some(profile => context.user.profile.code.includes(profile)),
    [context.user]
  );

  const hasResource = useCallback(
    (resources: UserPermission[]) => {
      return !context.user.resources?.length
        ? true
        : resources.some(resource => context.user.resources?.map(item => item.name).includes(resource));
    },
    [context.user]
  );

  return { ...context, hasProfiles, hasResource };
};
